module.exports = __webpack_public_path__ + "img/progress-oman-bar.ff34c14d.svg";